import 'css-chunksrc/client/pages/projectPage/sideBar/externalLinksList/linkMenu/styles.scss';export default {
  "linkMenu": "_linkMenu_1i7pc_1",
  "option": "_option_1i7pc_19",
  "iconBox": "_iconBox_1i7pc_43",
  "icon": "_icon_1i7pc_43",
  "text": "_text_1i7pc_55",
  "remove": "_remove_1i7pc_62"
};